import {Component, input} from '@angular/core';
import {NgForOf, NgIf} from '@angular/common';
import {ApiService} from '../../_services/api.service';
import {FormItem} from '../../_models/formitem';
import {FormListRowComponent} from './form-list-row/form-list-row.component';

@Component({
  selector: 'app-form-list',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    FormListRowComponent
  ],
  templateUrl: './form-list.component.html',
  styleUrl: './form-list.component.scss'
})
export class FormListComponent {
  forms = input.required<FormItem[]>();

  constructor(protected apiService: ApiService) {
  }
}
